import { useGetIdentity } from 'react-admin';
import { UserRole } from '../types/types';

export const useRecycleSellerContext = () => {
    const { identity, isLoading } = useGetIdentity();
    const roleId = identity?.role_id;
    const isSeller = roleId === UserRole.Seller;
    const sellerId = identity?.id ? Number(identity.id) : null;
    const sellerLabel =
        identity?.fullName?.trim() ||
        localStorage.getItem('user_name') ||
        (sellerId != null ? String(sellerId) : '');

    return {
        isLoading,
        isSeller,
        isAdmin: roleId === UserRole.Admin,
        sellerId,
        sellerLabel,
    };
};
